import { useState, useEffect, useCallback } from 'react';
import { supabase, UserRecommendation, RecommendationsResponse } from '../lib/supabase';

export function useRecommendations(userId: string | undefined, lang: string = 'fr') {
  const [activeRecommendations, setActive] = useState<UserRecommendation[]>([]);
  const [lockedRecommendation, setLocked] = useState<UserRecommendation | null>(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    const { data: rpcData, error } = await supabase.rpc('get_user_recommendations', { p_lang: lang });
    if (error) {
      console.error('get_user_recommendations error:', error);
    } else {
      const resp = rpcData as unknown as RecommendationsResponse;
      setActive(resp?.active ?? []);
      setLocked(resp?.locked ?? null);
    }
    setLoading(false);
  }, [userId, lang]);

  useEffect(() => { fetch(); }, [fetch]);

  const refresh = useCallback(async () => {
    if (!userId) return;
    await supabase.rpc('generate_user_recommendations');
    await fetch();
  }, [userId, fetch]);

  return { activeRecommendations, lockedRecommendation, loading, refresh, refetch: fetch };
}
